import * as regulamento from './regulamento';

export const constants = { regulamento };
